import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardsListButton: {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
  }),
);
